import { ENTITLEMENTS } from '../../application-core/constants';
import HistoryIcon from '@material-ui/icons/History';
import GetAppIcon from '@material-ui/icons/GetApp';
import InsertChartIcon from '@material-ui/icons/InsertChartOutlined';
import LinearScaleIcon from '@material-ui/icons/LinearScale';
import PropTypes from 'prop-types';
import { Component, default as React } from 'react';
import ComponentBody from '../../core/ComponentBody';
import HistoryViewer from '../../core/HistoryViewer';
import HierarchyIcon from '../../core/icons/Hierarchy';
import InAppBar from '../../core/InAppBar';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import TripleViewer from '../../core/TripleViewer';
import { getGraphFromProject } from '../../core/utils/utils';
import withGS from '../../core/withGShoc';
import ComponentDetail from '../../core/ComponentDetail';
import CollectionExport from './CollectionExport';
import CollectionStatistics from './CollectionStatistics';

class CollectionData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      view: 0
    };
  }

  changeView = (index) => this.setState({ view: index });

  toggleCollectionDetail = () => this.props.toggleCollectionDetail(1);

  render() {

    const { collectionIRI, data, projectIRI, entitlements } = this.props;
    const { view } = this.state;
    const graph = getGraphFromProject(projectIRI);

    const appBar = <InAppBar
      tabValue={view}
      onChangeTab={this.changeView}
      tabItems={[{
        icon: HierarchyIcon,
        label: "Detail"
      },
      {
        icon: LinearScaleIcon,
        label: "Triples"
      },
      {
        icon: HistoryIcon,
        label: "History"
      },
      {
        icon: InsertChartIcon,
        label: "Statistics"
      },
      {
        icon: GetAppIcon,
        label: "Export"
      }]} />;

    const maxWidth = [800, null, null, 800, null][view];
    const ordered = this.props.data.type.includes("OrderedCollection");

    return (
      <ProjectConsumer>
        {({ defaultLang, skosXL, ontologyProjectAssociation }) => (
          <ComponentBody maxWidth={maxWidth} title={data.title} id={data.id} onToggleView={this.toggleCollectionDetail} appBar={appBar}>
            {view === 0 && <ComponentDetail
              id={collectionIRI}
              includeTemplates={true}
              includeNotes={true}
              baseInferredClass={ordered ?
                "http://www.w3.org/2004/02/skos/core#OrderedCollection"
                :
                "http://www.w3.org/2004/02/skos/core#Collection"}
              includeAdditionalMetadata={true}
              entitlements={entitlements}
              canHideProps={
                [
                  {
                    label: "Hidden Label",
                    property: "http://www.w3.org/2004/02/skos/core#hiddenLabel"
                  },
                  {
                    label: "Broad Match",
                    property: "http://www.w3.org/2004/02/skos/core#broadMatch"
                  },
                  {
                    label: "Close Match",
                    property: "http://www.w3.org/2004/02/skos/core#closeMatch"
                  },
                  {
                    label: "Exact Match",
                    property: "http://www.w3.org/2004/02/skos/core#exactMatch"
                  },
                  {
                    label: "Narrow Match",
                    property: "http://www.w3.org/2004/02/skos/core#narrowMatch"
                  },
                  {
                    label: "Related Match",
                    property: "http://www.w3.org/2004/02/skos/core#relatedMatch"
                  },
                  {
                    label: "Notation",
                    property: "http://www.w3.org/2004/02/skos/core#notation"
                  }, {
                    label: "Change Note",
                    property: "http://www.w3.org/2004/02/skos/core#changeNote"
                  },
                  {
                    label: "Definition",
                    property: "http://www.w3.org/2004/02/skos/core#definition"
                  },
                  {
                    label: "Editorial Note",
                    property: "http://www.w3.org/2004/02/skos/core#editorialNote"
                  },
                  {
                    label: "Example",
                    property: "http://www.w3.org/2004/02/skos/core#example"
                  },
                  {
                    label: "History Note",
                    property: "http://www.w3.org/2004/02/skos/core#historyNote"
                  },
                  {
                    label: "Scope Note",
                    property: "http://www.w3.org/2004/02/skos/core#scopeNote"
                  },
                  {
                    label: "Top Concept Of",
                    property: "http://www.w3.org/2004/02/skos/core#topConceptOf"
                  }
                ]}
              graph={graph}
              entitlement={ENTITLEMENTS.EDIT_TAXONOMY}
              includeSlashHash={false} />}
            {view === 1 && <TripleViewer id={collectionIRI} graph={graph} displayTitle={false} />}
            {view === 2 && <HistoryViewer
              id={collectionIRI}
              graph={graph}
              options={[
                {
                  label: "Collection Only",
                },
                {
                  label: "All Resources In Collection",
                  resource: true,
                  isReversed: true,
                  path: ordered ?
                    "http://www.w3.org/2004/02/skos/core#memberList"
                    :
                    "http://www.w3.org/2004/02/skos/core#member"
                }
              ]}
              onToggleView={this.toggleCollectionDetail}
              displayTitle={false} />}
            {view === 3 && <CollectionStatistics id={collectionIRI} graph={graph} ordered={ordered} />}
            {view === 4 && <CollectionExport
              id={collectionIRI}
              graph={graph}
              examples={ordered ?
                data.memberList ?
                  data.memberList.slice(0, 3)
                  :
                  []
                :
                data.member ?
                  data.member.slice(0, 3)
                  :
                  []}
              entitlements={entitlements}
              skosXL={skosXL}
              defaultLang={defaultLang}
              ontologyProjectAssociation={ontologyProjectAssociation}
              ordered={ordered} />}
          </ComponentBody>
        )}
      </ProjectConsumer>
    );
  }

}

CollectionData.propTypes = {
  entitlements: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  projectIRI: PropTypes.string.isRequired,
  collectionIRI: PropTypes.string.isRequired,
  toggleCollectionDetail: PropTypes.func.isRequired
};

export default withGS(CollectionData);